import React, { PropTypes } from 'react';

const Icon = ({glyph, className = ''}) => {
    return (
        <svg className={`svg-icon ${className}`}>
            <use xlinkHref={`#${glyph}`} />
        </svg>
    );
};

Icon.propTypes = {
    glyph: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default Icon;



/** WEBPACK FOOTER **
 ** ./src/components/icon/Icon.jsx
 **/